import { TIdToPageConfigMap } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { PageIdStylioSnrs } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_STYLIO_SNRS: TIdToPageConfigMap = {
  [PageIdStylioSnrs.AGE_SNRS]: {
    id: PageIdStylioSnrs.AGE_SNRS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    progressBar: 'controlled',
    progressBarHidden: true,
  },
  [PageIdStylioSnrs.URGE_SNRS]: {
    id: PageIdStylioSnrs.URGE_SNRS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioSnrs.HAIR_COLOR_SNRS]: {
    id: PageIdStylioSnrs.HAIR_COLOR_SNRS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.EYES_COLOR_SNRS]: {
    id: PageIdStylioSnrs.EYES_COLOR_SNRS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.JEWELRY_SNRS]: {
    id: PageIdStylioSnrs.JEWELRY_SNRS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.BODY_SHAPE_SNRS]: {
    id: PageIdStylioSnrs.BODY_SHAPE_SNRS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.STYLIO_TO_HELP_SNRS]: {
    id: PageIdStylioSnrs.STYLIO_TO_HELP_SNRS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.TALL_SNRS]: {
    id: PageIdStylioSnrs.TALL_SNRS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.WEIGHT_SNRS]: {
    id: PageIdStylioSnrs.WEIGHT_SNRS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.URGE_2_SNRS]: {
    id: PageIdStylioSnrs.URGE_2_SNRS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioSnrs.SHOPPING_SNRS]: {
    id: PageIdStylioSnrs.SHOPPING_SNRS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.STYLE_MOST_MATTERS_SNRS]: {
    id: PageIdStylioSnrs.STYLE_MOST_MATTERS_SNRS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.FAVORITE_COLORS_SNRS]: {
    id: PageIdStylioSnrs.FAVORITE_COLORS_SNRS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.LIKE_OR_DISLIKE_SNRS]: {
    id: PageIdStylioSnrs.LIKE_OR_DISLIKE_SNRS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.LIKE_OR_DISLIKE_11_SNRS]: {
    id: PageIdStylioSnrs.LIKE_OR_DISLIKE_11_SNRS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.LIKE_OR_DISLIKE_12_SNRS]: {
    id: PageIdStylioSnrs.LIKE_OR_DISLIKE_12_SNRS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.LIKE_OR_DISLIKE_13_SNRS]: {
    id: PageIdStylioSnrs.LIKE_OR_DISLIKE_13_SNRS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.LIKE_OR_DISLIKE_14_SNRS]: {
    id: PageIdStylioSnrs.LIKE_OR_DISLIKE_14_SNRS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.LIKE_OR_DISLIKE_15_SNRS]: {
    id: PageIdStylioSnrs.LIKE_OR_DISLIKE_15_SNRS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.LIKE_OR_DISLIKE_16_SNRS]: {
    id: PageIdStylioSnrs.LIKE_OR_DISLIKE_16_SNRS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.LIKE_OR_DISLIKE_17_SNRS]: {
    id: PageIdStylioSnrs.LIKE_OR_DISLIKE_17_SNRS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.STYLES_FEEL_LIKE_YOU_SNRS]: {
    id: PageIdStylioSnrs.STYLES_FEEL_LIKE_YOU_SNRS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.URGE_4_SNRS]: {
    id: PageIdStylioSnrs.URGE_4_SNRS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioSnrs.BRAND_SNRS]: {
    id: PageIdStylioSnrs.BRAND_SNRS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.FIND_NEW_CLOTHES_SNRS]: {
    id: PageIdStylioSnrs.FIND_NEW_CLOTHES_SNRS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.NOTHING_TO_WEAR_SNRS]: {
    id: PageIdStylioSnrs.NOTHING_TO_WEAR_SNRS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.OLD_CLOTHES_SNRS]: {
    id: PageIdStylioSnrs.OLD_CLOTHES_SNRS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.COMBINE_CLOTHES_SNRS]: {
    id: PageIdStylioSnrs.COMBINE_CLOTHES_SNRS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.OUTFIT_LOOK_SNRS]: {
    id: PageIdStylioSnrs.OUTFIT_LOOK_SNRS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.OPTIMIZE_BUDGET_SNRS]: {
    id: PageIdStylioSnrs.OPTIMIZE_BUDGET_SNRS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.EVERYDAY_LIFESTYLE_SNRS]: {
    id: PageIdStylioSnrs.EVERYDAY_LIFESTYLE_SNRS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.CLIMAT_SNRS]: {
    id: PageIdStylioSnrs.CLIMAT_SNRS,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioSnrs.URGE_3_SNRS]: {
    id: PageIdStylioSnrs.URGE_3_SNRS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioSnrs.PREPARE_FLOW_SNRS]: {
    id: PageIdStylioSnrs.PREPARE_FLOW_SNRS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioSnrs.EMAIL_SNRS]: {
    id: PageIdStylioSnrs.EMAIL_SNRS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioSnrs.EMAIL_CONSENT_SNRS]: {
    id: PageIdStylioSnrs.EMAIL_CONSENT_SNRS,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioSnrs.SUBSCRIPTIONS_SNRS]: {
    id: PageIdStylioSnrs.SUBSCRIPTIONS_SNRS,
  },
  [PageIdStylioSnrs.CANCEL_OFFER_SNRS]: {
    id: PageIdStylioSnrs.CANCEL_OFFER_SNRS,
  },
  [PageIdStylioSnrs.SUB_UPSELL_SNRS]: {
    id: PageIdStylioSnrs.SUB_UPSELL_SNRS,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioSnrs.UPSELL_SNRS]: {
    id: PageIdStylioSnrs.UPSELL_SNRS,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioSnrs.DOWNLOAD_SNRS]: {
    id: PageIdStylioSnrs.DOWNLOAD_SNRS,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
}
